/**
 * Generates a unique idempotency key for POST mutations.
 * Format: fe-<timestamp>-<random hex>
 */
export function generateIdempotencyKey(): string {
  const rand = Math.random().toString(16).slice(2, 10);
  return `fe-${Date.now()}-${rand}`;
}
